var map = {
	"./19.JPG": 185,
	"./20210501_091914726_iOS.jpg": 186,
	"./22.jpg": 187,
	"./Close-1.JPG": 188,
	"./CloseUp2.jpeg": 189,
	"./IMG-20230508-WA0172.jpg": 190,
	"./IMG-20230508-WA0173.jpg": 191,
	"./IMG-20230508-WA0175.jpg": 192,
	"./IMG-20230508-WA0176.jpg": 193,
	"./IMG-20230508-WA0177.jpg": 194,
	"./IMG-20230508-WA0178.jpg": 195,
	"./Veg.png": 196,
	"./WhatsApp Image 2021-02-23 at 22.46.54.jpeg": 197,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (17).jpeg": 198,
	"./_23.jpg": 199,
	"./event-3.jpg": 200,
	"./event-6.JPG": 201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;